import { render } from "./role-type.vue?vue&type=template&id=2aa99b65"
import script from "./role-type.vue?vue&type=script&lang=js"
export * from "./role-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__